import {
	Button,
	ButtonGroup,
	Dialog,
	IconButton,
	Link,
	Modal,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tooltip,
	Typography,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import PageHeading from '../../Components/PageHeading';
import { AppColors } from '../../Utils/helper/AppColors';
import { MdContentCopy, MdOutlineMoreTime, MdOutlineStopCircle } from 'react-icons/md';
import { FiEdit2 } from 'react-icons/fi';
import { PATH_NAME } from '../../Routes/Pathname';
import { generatePath, useLocation, useNavigate } from 'react-router-dom';
import DotChip from '../../Components/DotChip';
import UsersList from '../../Components/UsersList';
import SearchBar from '../../Components/SearchBar';
import CreateCampaignModal from './Components/CreateCampaignModal';
import moment from 'moment/moment';
import CultService from '../../Services/CultService';
import { HelperTexts } from '../../Utils/helper/HelperTexts';
import toast from 'react-hot-toast';
import PageLoader from '../../Components/PageLoader';
import { AddIcon, ArchiveIcon, CheckCircleIcon, CheckIcon, CloseIcon, CopyIcon, DeleteIcon, InfoIcon, RefreshIcon, UnarchiveIcon , CloudDownloadIcon } from '../../Components/Icons/Icons';
import DeleteConfirm from '../../Components/DeleteConfirm';
import { CAMPAIGN_STATUS } from '../../Utils/helper/AppConstants';
import { useSelector } from 'react-redux';
import { filterBySearch, filterBySearchPagination, getColorSettings, getSafePageAfterProcess } from '../../Utils/helper/commonUtils';
import ExtendCampaignModal from './Components/ExtendCampaignModal';
import CustomTablePagination from '../../Components/CustomTablePagination';
import EditCampaign from './EditCampaign';
import CustomTag from '../../Components/CustomTag';
import CampaignCreateOrDuplicateModal from './Components/CampaignCreateOrDuplicateModal';
import CampaignSuccessModal from './Components/CampaignSuccessModal';
import DataNotFound from '../../Components/DataNotFound';
import CustomInfoTooltip from '../../Components/CustomInfoTooltip';
import { theme } from 'antd';
import { debounce } from 'lodash';

export default function CampaignList() {
	const navigate = useNavigate();
	const location = useLocation();
	const [list, setList] = useState([]);
	const [open, setOpen] = useState(false);
	const [openCreateModal, setOpenCreateModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [deleting, setDeleting] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const [duplicateConfirm, setDuplicateConfirm] = useState(false);
	const [stopModal, setStopModal] = useState(false);
	const [syncModal, setSyncModal] = useState(false);
	const [archive , setArchive] = useState(null);
	const [pdfDownloadModel, setPdfDownloadModel] = useState(null);
	const [search, setSearch] = useState('');
	const [showExtend, setShowEntend] = useState(false);
	const [editCampaignData, setEditCampaignData] = useState(null);
	const [pagination, setPagination] = useState({ count: 0, rowsPerPage: 10, page: 1 });
	const company = useSelector((state) => state?.app?.company);

	const [showSuccess, setShowSuccess] = useState(false);

	const [viewType, setViewType] = useState(0); // 0 - [live, completed, draft] , 1 - [archived]
	const getList = async (page = 1, limit = pagination?.rowsPerPage, searchTerm = search || '' , viewType = 0) => {
		setLoading(true);
		try {
			let status = [];
            if(viewType === 0) {
                status = ['live','completed','draft','stopped'];
				setViewType(0);
            } else {
                status = ['archived'];
				setViewType(1);
            }
			let res = await CultService.getCampaignListV2({ params: { companyId: company?._id, page, limit, search : searchTerm , status: status } });
			if (res.status == 200) {
				setList(res?.data);
				setPagination({
					count: res.pagination?.total || 0,
					rowsPerPage: res.pagination?.limit || 10,
					totalPages: res.pagination?.totalPages || 1,
					page: res.pagination?.page || 1,
				});
			}
		} catch (err) {
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	const handleDeleteCampaign = async () => {
		setDeleting(true);
		try {
			const res = await CultService.deleteCampaign({ params: { id: deleteModal } });
			if (res.status == 200) {
				setDeleteModal(false);
				getList(getSafePageAfterProcess(list?.length,pagination?.page), pagination?.rowsPerPage, search, viewType);
			}
		} catch (err) {
		} finally {
			setDeleting(false);
		}
	};

	const handleStopCampaign = async () => {
		setDeleting(true);
		try {
			const res = await CultService.updateCampaignStatus({
				params: { id: stopModal },
				data: { status: CAMPAIGN_STATUS?.stopped?.code },
			});
			if (res.status == 200) {
				setStopModal(false);
				getList(pagination?.page);
			}
		} catch (err) {
		} finally {
			setDeleting(false);
		}
	};

	const handleDownloadCampaignReportPDF = async (campaignId) => {
		setDeleting(true);
		try {
			const res = await CultService.getCampaignReportPDF({ params: { campaignId: pdfDownloadModel?._id || campaignId } });
			console.log('res', res);
			if (res.status == 200) {
				toast.success(res?.data?.message);
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setPdfDownloadModel(null);
			setDeleting(false);
		}
	};

	const handleDownloadPdf = (url, fileName = 'report.pdf') => {
            const link = document.createElement('a');
  
            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
     };

	const handleArchiveUnarchiveCampaign = async (campaignId) => { 
		setDeleting(true);
		try {
			const res = await CultService.setCampaignArchiveStatus({ params: { campaignId: campaignId } });
			if (res.status == 200) {
				toast.success(res?.data?.message || 'Campaign archived successfully');
				getList(getSafePageAfterProcess(list?.length,pagination?.page), pagination?.rowsPerPage, search, viewType);
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setDeleting(false);
			setArchive(null);
		}
	};

	const handleDuplicateCampaign = async () => {
		setDeleting(true);
		const compaign = duplicateConfirm;
		const body = {
			basicDetails: compaign?.basicDetails,
			scheduling: compaign?.scheduling,
			email: compaign?.email,
			users: compaign?.compaignUser,
			assistantId: compaign?.assistantId,
			status: compaign?.status,
			companyId: compaign?.companyId,
		};
		try {
			const res = await CultService.createCampaign({ data: body });
			if (res.status == 200) {
				setDuplicateConfirm(false);
				getList();
			}
		} catch (err) {
			toast.error(err?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setDeleting(false);
		}
	};

	const isExtendable = (company) => {
		let currentEndDate = company?.scheduling?.endDate;
		let currentEndTime = company?.scheduling?.endTime;
		let current = moment(currentEndDate + currentEndTime, 'YYYY-MM-DDHH:mm:ss');
		const diffInHours = current.diff(moment().format(), 'H');
		if (diffInHours > 24) {
			return true;
		} else {
			return false;
		}
	};

	const handleSyncCampaign = async () => {
		setDeleting(true);
		try {
			const res = await CultService.syncCampaign({ params: { id: syncModal } });
			if (res.status == 200) {
				setSyncModal(false);
				toast.success(res?.data?.message || 'Campaign synced successfully');
				getList(pagination?.page);

			}
		} catch (err) {
			toast.error(err?.data?.error || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setDeleting(false);
		}
	};

	const debouncegetList = debounce((searchTerm) => {
		console.log('debounce search', searchTerm);
		getList(1, pagination?.rowsPerPage, searchTerm);
	}, 1000);


	useEffect(() => {
		if (company?._id) {
			debouncegetList(search);
		}
	}, [company , search]);

	

	useEffect(() => {
		if (location?.state?.create) {
			setOpen(true);
		}
	}, []);

	useEffect(() => {
		if (location.state?.createdNewCampignSuccesfully) {
			setShowSuccess(true);
			// Remove the state so it doesn't show again on refresh
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location, navigate]);

	const localSettingColors = getColorSettings();

	return (
		<>
			<Stack sx={{ padding: 2 }} spacing={2} position="relative">
				<PageHeading title="Campaigns" subTitle="Easily create, track, and manage all your campaigns in one place." />

				<Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
					<SearchBar
						search={search}
						setSearch={setSearch}
						color={AppColors.midnight_black || localSettingColors?.fontColor}
						bgColor={AppColors.lightest_grey || localSettingColors?.quinary}
						width={'50%'}
					/>

					<Stack direction="row" alignItems="center" spacing={1}>
					 <ButtonGroup>
				<Button
					variant={viewType === 0 ? 'contained' : 'outlined'}
					color='info'
					onClick={() => { if(viewType !== 0) getList(1,10,search, 0); }}
				>
					All Campaigns
				</Button>
				<Button
					variant={viewType === 1 ? 'contained' : 'outlined'}
					color='info'
					onClick={() => {if(viewType !== 1) getList(1,10,search, 1); }}
				>
					Archived Campaigns
				</Button>
			</ButtonGroup> 

					<Button
						startIcon={<AddIcon color={AppColors.WHITE} />}
						onClick={() => setOpenCreateModal(true)}
						variant="contained"
						color="info"
					>
						Create Campaign
					</Button>
					</Stack>
				</Stack>

				<TableContainer sx={{ height: 'calc(100vh - 180px)', overflow: 'auto', backgroundColor: AppColors.WHITE }}>
					{list?.length === 0 ? (
						<DataNotFound />
					) : (
						<Table stickyHeader>
							<TableHead
								sx={{ '& .MuiTableCell-root': { fontSize: 14, color: AppColors.midnight_black || AppColors.BLACK, fontWeight: 600, paddingY: '16px' } }}
							>
								<TableCell sx={{ width: '20%' }}>Campaign Name</TableCell>
								<TableCell >Type</TableCell>

								<TableCell>Start/End Date</TableCell>

								<TableCell>Target Audience</TableCell>
								<TableCell>Status</TableCell>
								<TableCell> Action </TableCell>
							</TableHead>
							<TableBody>
								{list?.map((c, index) => (
									<TableRow key={index}>
										{/* Campaign Name */}
										<TableCell
											sx={{
												width: '30%',
												maxWidth: 0, // Ensures the cell doesn't grow beyond the width
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
												py: 1.5,
											}}
										>
											<Stack direction="row" alignItems="center" gap={1}>
												<Link
													sx={(theme) => ({
														color: theme.palette.primary.darker_primary,
														maxWidth: '60%',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
														':hover': { color: AppColors.TEXT_PRIMARY },
													})}
													fontSize={14}
													fontWeight={600}
													lineHeight={'150%'}
													fontFamily={'Poppins'}
													onClick={() => navigate(generatePath(PATH_NAME.CAMPAIGN_DETAILS, { id: c?._id }))}
													variant="subtitle1"
												>
													{c?.basicDetails?.name}
												</Link>
												{/* <Tooltip title={c?.basicDetails?.}> */}

												{c?.basicDetails?.description && <CustomInfoTooltip title={c?.basicDetails?.description} />}
												{/* </Tooltip> */}
											</Stack>
											{c?.basicDetails?.description && (
												<Stack direction="row" alignItems="center" gap={0.5}>
													<Typography
														sx={{
															overflow: 'hidden',
															textOverflow: 'ellipsis',
															whiteSpace: 'nowrap',
															fontFamily: 'Poppins',
															fontWeight: 400,
															fontSize: 14,
															lineHeight: '150%',
															color: AppColors.HEADING_TITLE3,
														}}
													>
														{c?.basicDetails?.description}
													</Typography>
													{/* <Tooltip title={c?.basicDetails?.description}>
												<Stack>
													<InfoIcon />
												</Stack>
											</Tooltip> */}
												</Stack>
											)}
										</TableCell>
                                        {/* Type */}
										<TableCell sx={{ py: 1.5 }}>
											{c?.basicDetails?.campaignType ?
											(<CustomTag
												tagTitle={c?.basicDetails?.campaignType}
												colorsInfo={{ "color": AppColors.midnight_black, "bgColor": AppColors.lightest_grey, "border": AppColors.light_grey }}
												fontSize={14}
												fontWeight={600}
												lineHeight={'150%'}
												px={12}
												py={2}
											/>) : (
												'--'
											)}
										</TableCell>
                                        {/* Start/End Date */}
										<TableCell sx={{ py: 1.5 }}>
											<Stack direction="row" alignItems="center">
												<Typography
													sx={{
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														fontFamily: 'Poppins',
														fontWeight: 600,
														fontSize: 14,
														lineHeight: '150%',
														color: AppColors.HEADING_TITLE4,
													}}
												>
													{c?.scheduling?.startDate ? moment(c.scheduling.startDate).format('MMM DD') : '--'} -
												</Typography>
												<Typography
													sx={{
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														fontFamily: 'Poppins',
														fontWeight: 600,
														fontSize: 14,
														lineHeight: '150%',
														color: AppColors.HEADING_TITLE4,
													}}
												>
													{c?.scheduling?.endDate ? moment(c.scheduling.endDate).format('MMM DD') : '--'}
												</Typography>
											</Stack>
										</TableCell>

                                        {/* Target Audience */}
										<TableCell sx={{ py: 1.5 }}>
											<UsersList users={c?.compaignUser?.map((i) => i.userId)} />
										</TableCell>
                                        
										{/* Status */}
										<TableCell sx={{ py: 1.5 }}>
											{/* {<DotChip color={CAMPAIGN_STATUS[c?.status]?.color} label={c?.status} />} */}
											<CustomTag
												tagTitle={c?.status?.charAt(0)?.toUpperCase() + c?.status?.slice(1)}
												colorsInfo={CAMPAIGN_STATUS[c?.status]}
												fontSize={14}
												fontWeight={600}
												lineHeight={'150%'}
												px={12}
												py={2}
											/>
										</TableCell>

                     					{/* Action */}
										<TableCell sx={{ py: 1.5 }}>
											<Stack direction="row" alignItems="center" gap={1}>
												{/* stop */}
												{c?.status === CAMPAIGN_STATUS?.live?.code && (
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	// bgcolor: '#ECE7FC',
																	// color: '#683FC7',
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																	// border: `1px solid ${theme.palette.primary.lightest_shade}`,
																},
															},
														}}
														arrow
														title="Stop Campaign"
													>
														<IconButton onClick={() => setStopModal(c._id)} size="small">
															<MdOutlineStopCircle size={18} color={AppColors.tomato_orange || localSettingColors.buttonBackground} />
														</IconButton>
													</Tooltip>
												)}

												{/* edit */}
												{c?.status === CAMPAIGN_STATUS?.draft?.code && (
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	// bgcolor: '#ECE7FC',
																	// color: '#683FC7',
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																	// border: `1px solid ${theme.palette.primary.lightest_shade}`,
																},
															},
														}}
														arrow
														title="Edit Campaign"
													>
														<IconButton
															onClick={() => navigate(PATH_NAME.CAMPAIGN_EDIT, { state: { campaign: { ...c, type: '0' } } })}
															size="small"
														>
															<FiEdit2 size={18} color={AppColors.tomato_orange || localSettingColors.buttonBackground} />
														</IconButton>
													</Tooltip>
												)}

												{/* delete */}
												{(c?.status === CAMPAIGN_STATUS?.draft?.code || c?.status === CAMPAIGN_STATUS?.stopped?.code) && (
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	// bgcolor: '#ECE7FC',
																	// color: '#683FC7',
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																	// border: `1px solid ${theme.palette.primary.lightest_shade}`,
																},
															},
														}}
														arrow
														title="Delete Campaign"
													>
														<IconButton onClick={() => setDeleteModal(c._id)} size="small">
															<DeleteIcon size={18} color={AppColors.tomato_orange || localSettingColors.buttonBackground} />
														</IconButton>
													</Tooltip>
												)}

												{/* extend */}
												{isExtendable(c) && c?.status === CAMPAIGN_STATUS?.live?.code && (
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	// bgcolor: '#ECE7FC',
																	// color: '#683FC7',
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																	// border: `1px solid ${theme.palette.primary.lightest_shade}`,
																},
															},
														}}
														arrow
														title="Extend Campaign"
													>
														<IconButton onClick={() => setShowEntend(c._id)} size="small">
															<MdOutlineMoreTime size={18} color={AppColors.tomato_orange || localSettingColors.buttonBackground} />
														</IconButton>
													</Tooltip>
												)}

												{/* duplicate */}

												{
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	// bgcolor: '#ECE7FC',
																	// color: '#683FC7',
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																	// border: `1px solid ${theme.palette.primary.lightest_shade}`,
																},
															},
														}}
														arrow
														title="Duplicate Campaign"
													>
														<IconButton
															onClick={() =>
																navigate(PATH_NAME.CAMPAIGN_COPY, { state: { campaign: { ...c, copy: true, type: '0' } } })
															}
															size="small"
														>
															<CopyIcon size={16} color={AppColors.tomato_orange || localSettingColors.buttonBackground} />
														</IconButton>
													</Tooltip>
												}

												{  c?.advancedOptionsEnabled && c?.status === CAMPAIGN_STATUS?.live?.code &&
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	// bgcolor: '#ECE7FC',
																	// color: '#683FC7',
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																	// border: `1px solid ${theme.palette.primary.lightest_shade}`,
																},
															},
														}}
														arrow
														title="Sync Campaign"
													>
														<IconButton
															onClick={() => {
																setSyncModal(c._id);}
															}
															size="small"
														>
															<RefreshIcon size={20} color={AppColors.tomato_orange || localSettingColors.buttonBackground} />
														</IconButton>
													</Tooltip>
												}

												{ ( c?.status === CAMPAIGN_STATUS?.stopped?.code || c?.status === CAMPAIGN_STATUS?.completed?.code ) &&
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																},
															},
														}}
														arrow
														title="Archive Campaign"
													>
														<IconButton
															onClick={() => {
																setArchive({id: c._id, status: c?.status});
															}}
															size="small"
														>
															<ArchiveIcon size={20} color={AppColors.tomato_orange || localSettingColors.buttonBackground} />
														</IconButton>
													</Tooltip>
												}

												{  c?.status === CAMPAIGN_STATUS?.archived?.code &&
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																},
															},
														}}
														arrow
														title="Unarchive Campaign"
													>
														<IconButton
															onClick={() => {
																setArchive({id: c._id, status: c?.status});
															}}
															size="small"
														>
															<UnarchiveIcon size={20} color={'#10b981'} />
														</IconButton>
													</Tooltip>
												}

												{(c?.status === CAMPAIGN_STATUS?.completed?.code && c?.hasAnyCallPickedUp ) && (
													//  c?.pdfUrl &&
													<Tooltip
														slotProps={{
															tooltip: {
																sx: {
																	boxShadow: '0 0 4 0 #B9B9F780',
																	radius: '5px',
																},
															},
														}}
														arrow
														title="Download Report PDF"
													>
														<IconButton
															onClick={() => {
																c?.pdf?.pdfUrl ? handleDownloadPdf(c.pdf.pdfUrl, `report_${c?.basicDetails?.name?.replace(/\s+/g, '_')}_campaign.pdf`) : setPdfDownloadModel(c);
															}}
															size="small"
														>
															<CloudDownloadIcon size={20} color={c?.pdf?.pdfUrl ? AppColors.tomato_orange : AppColors?.grey_text } />
														</IconButton>
													</Tooltip>
												)}
												{/* <IconButton onClick={() => setDuplicateConfirm(c)} size="small">
											<CopyIcon size={20} color={AppColors.TEXT_TERTIARY} />
										</IconButton> */}
											</Stack>
										</TableCell>
									</TableRow>
								))}
								<TableRow
									sx={{
										position: 'sticky',
										bottom: 0,
										backgroundColor: '#fff',
										paddingY: '8px',
										zIndex: 2, // Ensure it's above other rows
										// width:'10%'
									}}
								>
									<TableCell sx={{ py: '4px' }} colSpan={12} align="center">
										<CustomTablePagination
											{...pagination}
											onChange={(p, r) => getList(p, r , search , viewType)}
											onRowsPerPageChange={(e) => getList(1, e.target.value , search , viewType)}
										/>
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					)}
				</TableContainer>

				{/* <Modal type="blur" open={open}>
				<CreateCampaignModal open={open} setOpen={setOpen} fetch={getList} />
			</Modal>

			<Modal type="blur" open={openEdit} onClose={() => setOpenEdit(false)}>
				<EditCampaign open={openEdit} setOpen={setOpenEdit} fetch={getList} campaign={editCampaignData} />
			</Modal> */}

				<DeleteConfirm
					loading={deleting}
					open={stopModal}
					onDelete={handleStopCampaign}
					onClose={() => setStopModal(false)}
					title="Stop Campaign?"
					subTitle="Are you sure you want to stop this campaign?"
				/>

				<DeleteConfirm
					loading={deleting}
					open={deleteModal}
					onDelete={handleDeleteCampaign}
					onClose={() => setDeleteModal(false)}
					title="Delete Campaign?"
					subTitle="Are you sure you want to delete this campaign?"
				/>

				<DeleteConfirm
					loading={deleting}
					open={syncModal}
					onDelete={handleSyncCampaign}
					onClose={() => setSyncModal(false)}
					title="Sync Campaign?"
					subTitle="Are you sure you want to sync this campaign?"
				/>

				<DeleteConfirm
					loading={deleting}
					open={archive !== null}
					onDelete={() => handleArchiveUnarchiveCampaign(archive?.id)}
					onClose={() => setArchive(null)}
					title={archive?.status === CAMPAIGN_STATUS.archived.code ? 'Unarchive Campaign?' : 'Archive Campaign?'}
					subTitle={`Are you sure you want to ${
						archive?.status === CAMPAIGN_STATUS.archived.code ? 'unarchive' : 'archive'
					} this campaign?`}
				/>

				<DeleteConfirm
					loading={deleting}
					open={duplicateConfirm}
					onDelete={handleDuplicateCampaign}
					onClose={() => setDuplicateConfirm(false)}
					title="Duplicate Campaign?"
					subTitle="Are you sure you want to duplicate this campaign?"
				/>

				<DeleteConfirm
					loading={deleting}
					open={pdfDownloadModel !== null}
					onDelete={() => handleDownloadCampaignReportPDF(pdfDownloadModel?._id)}
					onClose={() => setPdfDownloadModel(null)}
					title={`Download Campaign Report`}
					subTitle={`Are you sure you want to download this campaign report?`}
				/>

				<Modal open={Boolean(showExtend)}>
					<ExtendCampaignModal id={showExtend} onClose={() => setShowEntend(false)} fetch={getList} />
				</Modal>
			</Stack>
			<CampaignSuccessModal open={showSuccess} onClose={() => setShowSuccess(false)} />
			<CampaignCreateOrDuplicateModal open={openCreateModal} onClose={() => setOpenCreateModal(false)} fetchCampaigns={getList} />
			{loading && <PageLoader />}
		</>
	);
}
